<template>
  <v-card class="timeline-profile" v-if="volunteer">
    <!-- Header -->
    <div class="profile-header">
      <h1 class="volunteer-name">{{ volunteer.first_name }} {{ volunteer.last_name }}</h1>
      <icon-button
        v-if="profile._id == volunteer._id"
        :onClicked="onEditName"
        icon="mdi-pencil"
        text="Edit Profile"
        class="edit-profile-btn"
      />
    </div>

    <!-- Timeline -->
    <div class="timeline">
      <!-- About Section -->
      <div class="timeline-item">
        <div class="timeline-badge about">
          <v-icon color="#3B7CA1">mdi-account</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>About Me</h2>
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditAboutMe"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
          <p class="about-text">{{ volunteer.about_me }}</p>
        </div>
      </div>

      <!-- Causes Section -->
      <div class="timeline-item">
        <div class="timeline-badge cause">
          <v-icon color="#3B7CA1">mdi mdi-account-heart</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>Causes</h2>
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditCause"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
          <div class="icon-grid">
            <site-icon
              v-for="(icon, key) in volunteer.causes"
              :key="'cause-'+key"
              :name="icon"
              type="Cause"
              small
            />
          </div>
        </div>
      </div>

      <!-- Interests Section -->
      <div class="timeline-item">
        <div class="timeline-badge interest">
          <v-icon color="#3B7CA1">mdi mdi-lightbulb-on-outline</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>Interests</h2>
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditInterest"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
          <div class="icon-grid">
            <site-icon
              v-for="(icon, key) in volunteer.interests"
              :key="'interest-'+key"
              :name="icon"
              type="Interest"
              small
            />
          </div>
        </div>
      </div>

      <!-- Contact Info Section -->
      <div class="timeline-item">
        <div class="timeline-badge contact">
             <v-icon color="#3B7CA1">mdi mdi-contacts-outline</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>Contact Information 
              <v-btn
                v-if="volunteer._id == profile._id"
                icon
                x-small
                @click="editPhoneAudience"
              >
                <v-icon small>{{
                  profile.phone_share_privacy
                    ? shareIcons[profile.phone_share_privacy]
                    : "mdi-lock"
                }}</v-icon>
              </v-btn></h2>
            
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditInformation"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
          <div class="info-list">
            <div class="info-item" v-if="volunteer.phone">
              <v-icon color="#0a5b8a">mdi-phone</v-icon>
              <span>{{ formatPhoneNumber(volunteer.phone) }}</span>
              <v-btn
                v-if="volunteer._id == profile._id"
                icon
                x-small
                @click="editPhoneAudience"
              >
                <v-icon small>{{
                  profile.phone_share_privacy
                    ? shareIcons[profile.phone_share_privacy]
                    : "mdi-lock"
                }}</v-icon>
              </v-btn>
            </div>
            <div class="info-item" v-if="volunteer.email">
              <v-icon color="#0a5b8a">mdi mdi-email-outline</v-icon>
              <span>{{ volunteer.email }}</span>
              <v-btn
                v-if="volunteer._id == profile._id"
                icon
                x-small
                @click="editPhoneAudience"
              >
                <v-icon small>{{
                  profile.email_share_privacy
                    ? shareIcons[profile.email_share_privacy]
                    : "mdi-lock"
                }}</v-icon>
              </v-btn>
            </div>
             <div class="info-item" v-if="volunteer.age_group">
              <v-icon color="#0a5b8a">mdi mdi-account-group-outline</v-icon>
              <span>{{ volunteer.age_group }}</span>
            </div>
          </div>
        </div>
      </div>


      <!-- Location Section --> 
      <div class="timeline-item">
        <div class="timeline-badge location">
          <v-icon color="#0a5b8a">mdi mdi-map-marker</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>Location</h2>
            <v-icon color="#3B7CA1" v-if="volunteer && volunteer.address_share_privacy !== 'Public'">mdi mdi-lock-open-outline</v-icon>
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditLocation"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
            <div class="info-item" v-if="volunteer.address">
            <!-- <v-icon color="#3B7CA1">mdi-map-marker</v-icon> -->
            <span>
                        {{
                `${volunteer.address}, 
              ${volunteer.city}, ${volunteer.state} ${volunteer.zip}`
              }}
            </span>
          </div>
          <div class="info-item" v-if="volunteer.address2">
            <!-- <v-icon color="#3B7CA1">mdi-map-marker</v-icon> -->
            <span>
               {{
                `${
                  volunteer.address2 ? " " + volunteer.address2 : ""
                }, 
              ${volunteer.city}, ${volunteer.state} ${volunteer.zip}`
              }}
            </span>
          </div>
        </div>
      </div>

      <!-- Availability Section -->
      <div class="timeline-item">
        <div class="timeline-badge availability">
          <v-icon color="#0a5b8a">mdi mdi-calendar-check</v-icon>
        </div>
        <div class="timeline-card">
          <div class="card-header">
            <h2>Availability</h2>
            <icon-button
              v-if="profile._id == volunteer._id"
              :onClicked="onEditAvailabilities"
              icon="mdi-pencil"
              text="Edit"
              class="edit-btn"
            />
          </div>
          <div class="availability-list">
            <div
              v-for="(availability, index) in filteredAvailabilities"
              :key="index"
              class="availability-item"
            >
              <v-icon class="availability-icon" color="#0a5b8a">mdi-calendar-clock</v-icon>
              <div class="availability-day">{{ availability.day }}</div>
              <div class="availability-time">{{ getScheduleTime(availability) }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog components remain the same -->

    <!-- Edit Dialogs -->
    <volunteer-profile-edit-name
      :dialog="editNameDialog"
      :onClose="onCloseEditDialog"
      v-if="editNameDialog"
    />
    <volunteer-profile-edit-about-me
      :dialog="editAboutMeDialog"
      :onClose="onCloseEditDialog"
      v-if="editAboutMeDialog"
    />
    <volunteer-profile-edit-information
      :dialog="editInformationDialog"
      :onClose="onCloseEditDialog"
      v-if="editInformationDialog"
    />
    <volunteer-profile-edit-location
      :dialog="editLocationDialog"
      :onClose="onCloseEditDialog"
      v-if="editLocationDialog"
    />
    <volunteer-profile-causes-dialog
      :dialog="editCauseDialog"
      :onClose="onCloseEditDialog"
      v-if="editCauseDialog"
    />
    <volunteer-profile-interests-dialog
      :dialog="editInterestDialog"
      :onClose="onCloseEditDialog"
      v-if="editInterestDialog"
    />
    <volunteer-profile-availabilities-dialog
      :dialog="editAvailabilities"
      :onClose="onCloseEditDialog"
      v-if="editAvailabilities"
    />
    <volunteer-profile-edit-audience
      :dialog="audienceDialog"
      :type="audienceType"
      :onClose="onCloseEditDialog"
      v-if="audienceDialog && audienceType"
    />
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import IconButton from "@/components/common/IconButton.vue";
import VolunteerProfileEditName from "./edit/VolunteerProfileEditName.vue";
import VolunteerProfileEditAboutMe from "./edit/VolunteerProfileEditAboutMe.vue";
import VolunteerProfileEditInformation from "./edit/VolunteerProfileEditInformation.vue";
import VolunteerProfileEditLocation from "./edit/VolunteerProfileEditLocation.vue";
import VolunteerProfileCausesDialog from "./edit/VolunteerProfileCausesDialog.vue";
import VolunteerProfileInterestsDialog from "./edit/VolunteerProfileInterestsDialog.vue";
import VolunteerProfileAvailabilitiesDialog from "./edit/VolunteerProfileAvailabilitiesDialog.vue";
import SiteIcon from "@/components/common/SiteIcon.vue";
import VolunteerProfileEditAudience from "./edit/VolunteerProfileEditAudience";
export default {
  components: {
    IconButton,
    VolunteerProfileEditName,
    VolunteerProfileEditAboutMe,
    VolunteerProfileEditInformation,
    VolunteerProfileEditLocation,
    VolunteerProfileCausesDialog,
    VolunteerProfileInterestsDialog,
    VolunteerProfileAvailabilitiesDialog,
    SiteIcon,
    VolunteerProfileEditAudience
  },
  data() {
    return {
      editNameDialog: false,
      editAboutMeDialog: false,
      editInformationDialog: false,
      editLocationDialog: false,
      editCauseDialog: false,
      editInterestDialog: false,
      editScheduleDialog: false,
      editAvailabilities: false,
      audienceDialog: false,
      audienceType: null,
      shareIcons: {
        "Only me": "mdi-lock",
        "Only agencies I fanned": "mdi-domain",
        "Only followed volunteers": "mdi-account-multiple",
        "All followed agencies and volunteers": "mdi-account-group",
        Public: "mdi-earth"
      }
    };
  },
  computed: {
    ...mapGetters({
      profile: "auth/getProfile",
      profileType: "auth/getType",
      volunteer: "volunteer/getVolunteer"
    }),
    filteredAvailabilities() {
      return this.volunteer.availabilities.filter(
        a => a.morning || a.afternoon || a.evening
      );
    }
  },
  methods: {
    ...mapActions("volunteer", {
      copyVolunteerFromProfile: "copyFromProfile"
    }),
    onEditName() {
      this.editNameDialog = true;
    },
    onEditAboutMe() {
      this.editAboutMeDialog = true;
    },
    onEditCause() {
      this.editCauseDialog = true;
    },
    onEditInterest() {
      this.editInterestDialog = true;
    },
    onEditSchedule() {
      this.editScheduleDialog = true;
    },
    onEditInformation() {
      this.editInformationDialog = true;
    },
    onEditLocation() {
      this.editLocationDialog = true;
    },
    onEditAvailabilities() {
      this.editAvailabilities = true;
    },
    getDay(schedule) {
      return schedule.split(" ")[0];
    },
    getScheduleTime(schedule) {
      let str = schedule.morning ? "Morning" : "";
      str = !schedule.afternoon ? str : str ? str + ", Afternoon" : "Afternoon";
      str = !schedule.evening ? str : str ? str + ", Evening" : "Evening";

      return str;
    },
    onCloseEditDialog() {
      this.editNameDialog = false;
      this.editAboutMeDialog = false;
      this.editInformationDialog = false;
      this.editLocationDialog = false;
      this.editCauseDialog = false;
      this.editInterestDialog = false;
      this.editAvailabilities = false;
      this.audienceDialog = false;
      this.copyVolunteerFromProfile();
    },
    formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");
      let match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        let intlCode = match[1] ? "+1 " : "";
        return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      }
      return str;
    },
    editPhoneAudience() {
      this.audienceType = "phone";
      this.audienceDialog = true;
    },
    editEmailAudience() {
      this.audienceType = "email";
      this.audienceDialog = true;
    },
    editAddressAudience() {
      this.audienceType = "address";
      this.audienceDialog = true;
    }
  }
};
</script>

<style scoped>
.timeline-profile {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-header {
  background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
  padding: 32px;
  color: white;
  text-align: center;
  position: relative;
}

.volunteer-name {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
}

.edit-profile-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  color: white;
}

.timeline {
  position: relative;
  padding: 40px 0;
  max-width: 900px;
  margin: 0 auto;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: 40px;
  height: 100%;
  width: 3px;
  background: linear-gradient(135deg, #3b7ca1 0%, #084468 100%);
}

.timeline-item {
  position: relative;
  padding-left: 80px;
  margin-bottom: 40px;
}

.timeline-badge {
  position: absolute;
  left: 28px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: white;
  border: 3px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.timeline-badge::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

/* .timeline-badge.about::after { background: #0a5b8a; } */
/* .timeline-badge.cause::after { background: #472583; } */
/* .timeline-badge.interest::after { background: #fdbc3a; } */
/* .timeline-badge.contact::after { background: #4caf50; } */
/* .timeline-badge.availability::after { background: #9c27b0; } */

.timeline-card {
  background: white;
  padding: 24px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.timeline-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.card-header h2 {
  font-size: 20px;
  color: #084468;
  margin: 0;
}

.edit-btn {
  color: #666;
}

.icon-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.about-text {
  line-height: 1.6;
  color: #555;
}

.info-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
}

.availability-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.availability-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f8fafc;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.availability-item:hover {
  background-color: #f1f5f9;
}

.availability-icon {
  margin-right: 12px;
}

.availability-day {
  font-weight: 500;
  min-width: 100px;
  color: #084468;
}

.availability-time {
  color: #4b5563;
  flex-grow: 1;
}

@media (max-width: 768px) {
  .timeline::before {
    left: 20px;
  }
  
  .timeline-item {
    padding-left: 60px;
  }
  
  .timeline-badge {
    left: 8px;
  }
  
  .profile-header {
    padding: 24px;
  }
  
  .volunteer-name {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .edit-btn {
    align-self: flex-end;
  }
  
  .timeline-card {
    padding: 16px;
  }
}
</style>